import { getConfig } from './init';

export class CsbHelper {
    static getLocale(): string {
        const lang = document.getElementsByTagName('html')[0].getAttribute('lang') || 'de_DE';
        const locale = lang.replace('-', '_');
        return locale;
    }

    static getImage(imageUrl: string): string {
        if (!imageUrl) {
            return '';
        }

        if (imageUrl.startsWith('http')) {
            return imageUrl;
        }

        let baseUrl = getConfig().storageUrl;
        if (baseUrl.endsWith('/') && imageUrl.startsWith('/')) {
            baseUrl = baseUrl.substring(0, baseUrl.length - 1);
            return baseUrl + imageUrl;
        } else {
            if (!baseUrl.endsWith('/') && !imageUrl.startsWith('/')) {
                return baseUrl + '/' + imageUrl;
            }
        }
        return baseUrl + imageUrl;
    }

    static async checkBlobExists(blobUrl: string): Promise<boolean> {
        try {
            const response = await fetch(blobUrl, { method: 'HEAD' });

            return response.status === 200;
        } catch (error) {
            console.error('Fehler beim Überprüfen des Blob-Existenzstatus:', error);
            return false;
        }
    }

    static getInternal(): boolean {
        //find out if site is internal job page by looking for our internal control which should only be rendered on internal pages
        const internalIndicator = document.body.querySelector('csb-internal');
        return !!internalIndicator;
    }

    static isInternalLoggedIn(): boolean {
        return !!document.querySelector('.empLogoutLink');
    }

    static isMobile(): boolean {
        const vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (vpWidth < 1024) {
            return true;
        }
        return false;
    }
    static isSmallMobile(): boolean {
        const vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (vpWidth < 768) {
            return true;
        }
        return false;
    }

    static async getBrand() {
        const brand = this.getBrandLocal();
        return { brand: brand, override: false };
    }

    static getBrandLocal(): string {
        const pathName = window.location.pathname.split('/')[1];
        let brand: string = pathName;
        if (!pathName || pathName === 'pages' || pathName === 'content' || pathName === 'job' || pathName === 'search') {
            const url = new URL(window.location.href);
            if (url.searchParams.get('brand')) {
                brand = url.searchParams.get('brand') as string;
            } else {
                brand = 'default';
            }
        }
        console.log('Locally resolved brand: ' + pathName);
        return brand;
    }
}
